import React from 'react';

/**
 * Dashboard Header Component
 * Displays the main dashboard title and average validation score
 * @param {Object} props - Component props
 * @param {number} props.averageScore - Overall average validation score
 * @returns {JSX.Element} Dashboard header
 */
export function DashboardHeader({ averageScore = 0 }) {
    return (
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-8 text-white">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold mb-2">Proofreading Dashboard</h1>
                    <p className="text-orange-100">
                        Monitor validation status and compliance across all Window World locations
                    </p>
                </div>
                <div className="text-right">
                    <div className="text-4xl font-bold">{averageScore}%</div>
                    <div className="text-orange-200">Average Score</div>
                </div>
            </div>
        </div>
    );
}

export default DashboardHeader;
